export const PREFIX = "point_of_sale"

export const SELECTED_LAYOUT = "selected_layout"
export const LAST_SELECTED_CARD_READER = "last_selected_card_reader"
export const SELECTED_DEFAULT_PRINTER_ID = "selected_default_printer_id"
export const SELECTED_SOLD_BY_USER = "selected_sold_by_user"
